import React from "react";
import { useTranslation } from "react-i18next";
import { Eyebrow } from "../components/ui.jsx";
import { useCurrentLocale } from "../lib/useLocaleNav.js";

export default function Privacy() {
  const { t } = useTranslation();
  const locale = useCurrentLocale();
  const list = t("legal.privacy.dataByYouList", { returnObjects: true });
  return (
    <main>
      <section className="bg-wash">
        <div className="container" style={{ padding: "56px 24px 56px", maxWidth: 880 }}>
          <Eyebrow>{t("legal.eyebrow")}</Eyebrow>
          <h1 className="tt-h tt-h-xl" style={{ marginTop: 24 }}>{t("legal.privacy.title")}</h1>
          <Html as="p" style={prose} html={t("legal.privacy.intro")} />
        </div>
      </section>

      <section style={{ padding: "8px 0 120px" }}>
        <div className="container" style={{ maxWidth: 820 }}>
          <H2>{t("legal.privacy.whoWeAreH")}</H2>
          <Html as="p" style={prose} html={t("legal.privacy.whoWeAreP1")} />
          <Html as="p" style={prose} html={t("legal.privacy.whoWeAreP2")} />

          <H3>{t("legal.privacy.dataByYouH")}</H3>
          <Html as="p" style={prose} html={t("legal.privacy.dataByYouP1")} />
          <ul style={listStyle}>
            {list.map((li, i) => <Html key={i} as="li" html={li} />)}
          </ul>

          <H3>{t("legal.privacy.autoH")}</H3>
          <Html as="p" style={prose} html={t("legal.privacy.autoP", { locale })} />

          <H2>{t("legal.privacy.purposesH")}</H2>
          <Html as="p" style={prose} html={t("legal.privacy.purposesP")} />

          <H3>{t("legal.privacy.createH")}</H3>
          <Html as="p" style={prose} html={t("legal.privacy.createP1")} />
          <Html as="p" style={prose} html={t("legal.privacy.createP2")} />
          <Html as="p" style={prose} html={t("legal.privacy.createP3")} />

          <H3>{t("legal.privacy.identifyH")}</H3>
          <Html as="p" style={prose} html={t("legal.privacy.identifyP1")} />
          <Html as="p" style={prose} html={t("legal.privacy.identifyP2")} />
          <Html as="p" style={prose} html={t("legal.privacy.identifyP3")} />

          <H3>{t("legal.privacy.contactH")}</H3>
          <Html as="p" style={prose} html={t("legal.privacy.contactP1")} />
          <Html as="p" style={prose} html={t("legal.privacy.contactP2")} />
          <Html as="p" style={prose} html={t("legal.privacy.contactP3")} />

          <H3>{t("legal.privacy.supportH")}</H3>
          <Html as="p" style={prose} html={t("legal.privacy.supportP1")} />
          <Html as="p" style={prose} html={t("legal.privacy.supportP2")} />
          <Html as="p" style={prose} html={t("legal.privacy.supportP3")} />

          <H3>{t("legal.privacy.twoStepH")}</H3>
          <Html as="p" style={prose} html={t("legal.privacy.twoStepP1")} />
          <Html as="p" style={prose} html={t("legal.privacy.twoStepP2")} />
          <Html as="p" style={prose} html={t("legal.privacy.twoStepP3")} />
          <Html as="p" style={prose} html={t("legal.privacy.twoStepP4")} />

          <H3>{t("legal.privacy.docsH")}</H3>
          <Html as="p" style={prose} html={t("legal.privacy.docsP1")} />
          <Html as="p" style={prose} html={t("legal.privacy.docsP2")} />

          <H3>{t("legal.privacy.commsH")}</H3>
          <Html as="p" style={prose} html={t("legal.privacy.commsP1")} />
          <Html as="p" style={prose} html={t("legal.privacy.commsP2")} />

          <H3>{t("legal.privacy.advertisingH")}</H3>
          <Html as="p" style={prose} html={t("legal.privacy.advertisingP1")} />
          <Html as="p" style={prose} html={t("legal.privacy.advertisingP2")} />
          <Html as="p" style={prose} html={t("legal.privacy.advertisingP3")} />

          <H2 id="google-business-profile">{t("legal.privacy.gbpH")}</H2>
          <Html as="p" style={prose} html={t("legal.privacy.gbpP1")} />
          <Html as="p" style={prose} html={t("legal.privacy.gbpP2")} />
          <Html as="p" style={prose} html={t("legal.privacy.gbpP3")} />
          <Html as="p" style={prose} html={t("legal.privacy.gbpP4")} />
          <Html as="p" style={prose} html={t("legal.privacy.gbpP5")} />
          <Html as="p" style={prose} html={t("legal.privacy.gbpP6")} />

          <H2>{t("legal.privacy.noProfilingH")}</H2>
          <Html as="p" style={prose} html={t("legal.privacy.noProfilingP")} />

          <H2>{t("legal.privacy.shareH")}</H2>

          <H3>{t("legal.privacy.shareExtH")}</H3>
          <Html as="p" style={prose} html={t("legal.privacy.shareExtP1")} />
          <Html as="p" style={prose} html={t("legal.privacy.shareExtP2")} />
          <Html as="p" style={prose} html={t("legal.privacy.shareExtP3")} />

          <H3>{t("legal.privacy.sharePubH")}</H3>
          <Html as="p" style={prose} html={t("legal.privacy.sharePubP")} />

          <H3>{t("legal.privacy.sharePublicH")}</H3>
          <Html as="p" style={prose} html={t("legal.privacy.sharePublicP1")} />
          <Html as="p" style={prose} html={t("legal.privacy.sharePublicP2")} />

          <H2>{t("legal.privacy.storageH")}</H2>
          <Html as="p" style={prose} html={t("legal.privacy.storageP1")} />
          <Html as="p" style={prose} html={t("legal.privacy.storageP2")} />
          <Html as="p" style={prose} html={t("legal.privacy.storageP3")} />
          <Html as="p" style={prose} html={t("legal.privacy.storageP4")} />

          <H2>{t("legal.privacy.rightsH")}</H2>
          <Html as="p" style={prose} html={t("legal.privacy.rightsAccess")} />
          <Html as="p" style={prose} html={t("legal.privacy.rightsRect")} />
          <Html as="p" style={prose} html={t("legal.privacy.rightsErase")} />
          <Html as="p" style={prose} html={t("legal.privacy.rightsRestrict")} />
          <Html as="p" style={prose} html={t("legal.privacy.rightsPort")} />
          <Html as="p" style={prose} html={t("legal.privacy.rightsWithdraw")} />
          <Html as="p" style={prose} html={t("legal.privacy.rightsExercise")} />

          <H2>{t("legal.privacy.complaintH")}</H2>
          <Html as="p" style={prose} html={t("legal.privacy.complaintP1")} />
          <Html as="p" style={prose} html={t("legal.privacy.complaintP2")} />

          <H2>{t("legal.privacy.changesH")}</H2>
          <Html as="p" style={prose} html={t("legal.privacy.changesP")} />
        </div>
      </section>
    </main>
  );
}

// Render translated text containing inline HTML (anchors, <strong>).
// Restricted to legal-page content authored in the locale files.
function Html({ as: Tag = "p", html, style, className }) {
  const linkified = wireLinkStyles(html);
  return <Tag style={style} className={className} dangerouslySetInnerHTML={{ __html: linkified }} />;
}

// Inject linkStyle attributes on bare <a href="..."> tags coming from the
// translations so legal-page links pick up the brand color/underline.
export function wireLinkStyles(html) {
  return html.replace(
    /<a\s+href="([^"]+)"([^>]*)>/g,
    (m, href, rest) =>
      rest.includes("style=")
        ? m
        : `<a href="${href}"${rest} style="color:var(--persimmon);text-decoration:underline;text-underline-offset:2px">`
  );
}

const prose = {
  marginTop: 16,
  fontSize: 16,
  lineHeight: 1.7,
  color: "var(--ink-2)",
  maxWidth: 760
};

const listStyle = {
  marginTop: 12,
  paddingLeft: 22,
  fontSize: 16,
  lineHeight: 1.7,
  color: "var(--ink-2)",
  maxWidth: 760,
  display: "flex",
  flexDirection: "column",
  gap: 10
};

function H2({ children, id }) {
  return (
    <h2
      id={id}
      className="tt-h tt-h-md"
      style={{ marginTop: 56, scrollMarginTop: 96 }}
    >
      {children}
    </h2>
  );
}

function H3({ children }) {
  return (
    <h3
      style={{
        marginTop: 32,
        fontFamily: "Satoshi, Inter, sans-serif",
        fontSize: 19,
        fontWeight: 700,
        letterSpacing: "-.012em",
        color: "var(--ink)"
      }}
    >
      {children}
    </h3>
  );
}
